import {debugActionTypes} from '@/store/actionTypes'
import $utils from "@/utils/utils"
import ScenarioService from "@/services/scenario.service";

const {NodeType} = ScenarioService

const findFlowNodes = (nodeList) => {
    // do this to avoid changing parameter
    let nodes = $utils.cloneObject(nodeList)
    if (!nodes || nodes.length === 0) {
        return {}
    }

    let flowData = nodes[0]
    for (let idx = 0; idx <= nodes.length; idx++) {
        if (idx > 0) {
            let child = flowData
            for (let i = 1; i < idx; i++) {
                child = child.children[0]
            }
            child.children = nodes[idx] ? [nodes[idx]] : []
        }
    }
    return flowData
}

const updateSuccessNodes = (nodeList) => {
    let successNodeList = []
    nodeList.forEach(item => {
        if (item.node.type === NodeType.RE_PROMPT) {
            return
        }

        if (!item.cardLogs) {
            successNodeList.push(item)
            return
        }

        let checkError = item.cardLogs.find(c => !!c.error)
        if (!checkError) {
            successNodeList.push(item)
        }
    })
    return successNodeList
}

const types = debugActionTypes

const state = {
    variables: [],
    monitoringVariables: [],
    callLogActivated: null,
    nodeList: [],
    nodesSuccess: [],
    treeData: {},
    debugNodeActivated: null,
    FSLog: null,
    isDataFlowError: false,
    callMonitor: null,
}

const mutations = {
    [types.VARIABLES]: (state, variables) => {
        state.variables = variables
    },
    [types.MONITORING_VARIABLES]: (state, monitoringVariables) => {
        state.monitoringVariables = monitoringVariables
    },
    [types.CALL_LOG_ACTIVATED]: (state, callLogActivated) => {
        state.callLogActivated = callLogActivated
    },
    [types.NODE_LIST]: (state, nodeList) => {
        state.nodeList = nodeList
    },
    [types.NODES_SUCCESS]: (state, nodesSuccess) => {
        state.nodesSuccess = nodesSuccess
    },
    [types.TREE_DATA]: (state, treeData) => {
        state.treeData = treeData
    },
    [types.DEBUG_NODE_ACTIVATED]: (state, debugNodeActivated) => {
        state.debugNodeActivated = debugNodeActivated
    },
    [types.ADD_MONITORING_VARS]: (state, listVariables) => {
        state.monitoringVariables = [...listVariables, ...state.monitoringVariables]
    },
    [types.DELETE_MONITORING_VAR]: (state, variable) => {
        let index = state.monitoringVariables.findIndex(i => i === variable)
        if (index > -1) {
            state.monitoringVariables.splice(index, 1)
        }
    },
    [types.FS_LOG]: (state, FSLog) => {
        state.FSLog = FSLog
    },
    [types.IS_DATA_FLOW_ERROR]: (state, isDataFlowError) => {
        state.isDataFlowError = isDataFlowError
    },
    [types.CALL_MONITOR]: (state, callMonitor) => {
        state.callMonitor = callMonitor
    },
}

const actions = {
    [types.RESET_ACTIVATED]({commit}) {
        commit(types.IS_DATA_FLOW_ERROR, false) // case này cần thêm vì khi mounted debug mode thì k reset IS_DATA_FLOW_ERROR
        commit(types.CALL_LOG_ACTIVATED, null)
        commit(types.TREE_DATA, {})
        commit(types.NODES_SUCCESS, [])
    },
    [types.UPDATE_DATA_FLOW]({commit}, {nodeList}) {
        commit(types.IS_DATA_FLOW_ERROR, false)
        commit(types.NODE_LIST, nodeList)
        commit(types.DEBUG_NODE_ACTIVATED, nodeList[0])

        // update success nodes
        let successNodeList = updateSuccessNodes(nodeList)
        commit(types.NODES_SUCCESS, successNodeList)

        // update data flow
        let treeFlow = findFlowNodes(nodeList)
        commit(types.TREE_DATA, treeFlow)
    },
    [types.NOTICE_DATA_FLOW_ERROR]({commit, dispatch}) {
        dispatch(types.RESET_ACTIVATED)
        commit(types.IS_DATA_FLOW_ERROR, true)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
